import React, { useEffect, useMemo, useState } from "react";
import { Box, IconButton, Modal, TextField, Button } from "@mui/material";

import Autocomplete from "@mui/material/Autocomplete";
import { ToastContainer, toast } from "react-toastify";
import {
  fetchClientNameData,
  fetchOrgClientWiseData,
  fetchroleorgwise,
  fetchUserByOrgWise,
  insertmapuserrole
} from "../../../../services/apiService";

const loginName = [
  { label: "The Shawshank Redemption" },
  { label: "The Godfather" },
  { label: "The Godfather: Part II" },
];

function AddGyanniUserRoleBase({ isModalOpen, closeModal }) {
  const clientid = localStorage.getItem("clientId");
  const mstorgnhierarchytypeid = localStorage.getItem("organizationid");

  if (!toast.isActive("userNotFound")) {
    toast("User does not exist", {
      toastId: "userNotFound",
      containerId: "friendRequest",
      position: "bottom-right",
      autoClose: false,
      closeOnClick: true,
      draggable: false,
      type: "error",
    });
  }

  const [selectedClient, setSelectedClient] = useState("");
  const [selectedOrgVal, setSelectedOrgVal] = useState("");
  const [organizationData, setOrganizationData] = useState([]);
  const [rollbasedData, setRollBasedData] = useState([]);
  const [clients, setClients] = useState([]);
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedParentVal, setSelectedParentVal] = useState("");
  const [selectedOrgRollParentVal, setSelectedOrgRollParentVal] = useState("");
  const [loginName, setLoginName] = useState([]);
  const [selectedLoginName, setSelectedLoginName] = useState(""); 


  useEffect(() => {
    if (isModalOpen) {
      fetchClientNames();
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (selectedClient) {
      handleOrgClientWise();
    }
  }, [selectedClient]);

  useEffect(() => {
    if (selectedParentVal) {
      fetchRollByOrgWise();
    }
  }, [selectedParentVal]);

  const fetchClientNames = async () => {
    const loadingToastId = toast.loading("Loading client data...", {
      toastId: "loadingClients",
      containerId: "clientContainer",
    });

    try {
      const response = await fetchClientNameData({});

      toast.dismiss(loadingToastId);

      if (response?.success && Array.isArray(response.details)) {
        setClients(response.details || []);

        if (!toast.isActive("clientLoaded")) {
          toast.success("Client data loaded successfully!", {
            toastId: "clientLoaded",
            autoClose: 2000,
            containerId: "clientContainer",
          });
        }
      } else {
        toast.error("Invalid response structure", {
          autoClose: 2000,
          containerId: "clientContainer",
        });
      }
    } catch (err) {
      console.error("Error fetching client name data:", err);
      toast.dismiss(loadingToastId);
      toast.error("Error fetching client name data.", {
        autoClose: 2000,
        containerId: "clientContainer",
      });
    }
  };

  const handleOrgClientWise = async () => {
    const loadingToastId = toast.loading("Fetching organization data...", {
      toastId: "orgLoading",
      containerId: "orgContainer",
    });

    try {
      if (!selectedClient) {
        toast.dismiss(loadingToastId);
        toast.error("Please select a client first.", {
          autoClose: 2000,
          containerId: "orgContainer",
        });
        return;
      }

      const clientId =
        typeof selectedClient === "string"
          ? parseInt(selectedClient, 10)
          : selectedClient;

      const response = await fetchOrgClientWiseData({ clientId });

      toast.dismiss(loadingToastId);

      if (response?.success && Array.isArray(response.details)) {
        setOrganizationData(response.details || []);
        if (!toast.isActive("orgLoaded")) {
          toast.success("Organization data loaded successfully!", {
            toastId: "orgLoaded",
            autoClose: 2000,
            containerId: "orgContainer",
          });
        }
      } else {
        toast.error("Error: Invalid response structure", {
          autoClose: 2000,
          containerId: "orgContainer",
        });
      }
    } catch (err) {
      console.error("Error fetching organization data:", err);
      toast.dismiss(loadingToastId);
      toast.error("Error fetching organization data.", {
        autoClose: 2000,
        containerId: "orgContainer",
      });
    }
  };

  const fetchRollByOrgWise = async () => {
    const loadingToastId = toast.loading("Fetching roll-based data...", {
      toastId: "roleLoading",
      containerId: "roleContainer",
    });

    try {
      if (!rollbasedData) {
        toast.dismiss(loadingToastId);
        toast.error("Please select an Organization first.", {
          autoClose: 2000,
          containerId: "roleContainer",
        });
        return;
      }


      const payload = {
        organizationid: parseInt(selectedParentVal, 10),
        clientid: Number(selectedClient),
      };

      const response = await fetchroleorgwise(payload);
      console.log("response", response);

      toast.dismiss(loadingToastId);

      if (response?.success && Array.isArray(response.details)) {
        setRollBasedData(response.details || []);
        if (!toast.isActive("roleLoaded")) {
          toast.success("Roll Based Organization data loaded successfully!", {
            toastId: "roleLoaded",
            autoClose: 2000,
            containerId: "roleContainer",
          });
        }
      } else {
        toast.error("Error: Invalid response structure", {
          autoClose: 2000,
          containerId: "roleContainer",
        });
      }
    } catch (err) {
      console.error("Error fetching roll-based data:", err);
      toast.dismiss(loadingToastId);
      toast.error("Error fetching data.", {
        autoClose: 2000,
        containerId: "roleContainer",
      });
    }
  };

  const handleSearchUser = async (inputValue) => {
    if (!inputValue || inputValue.length < 2) return;

    if (!selectedParentVal) {
      toast.error("Please select Roll first.", {
        autoClose: 2000,
        containerId: "orgContainer",
      });
      return;
    }

    const clientIdSelected =
      typeof selectedClient === "string"
        ? parseInt(selectedClient, 10)
        : selectedClient;

    const orgIdSelected =
      typeof selectedParentVal === "string"
        ? parseInt(selectedParentVal, 10)
        : selectedParentVal;

    const payload = {
      clientid: clientIdSelected,
      mstorgnhirarchyid: orgIdSelected,
      loginname: inputValue,
    };

    console.log("payload", payload);

    // Initialize the loading toast before using it
    const loadingToastId = toast.loading("Searching user...", {
      toastId: "searchingUser",
      containerId: "orgContainer",
    });

    try {
      // Fetch user data
      const response = await fetchUserByOrgWise(payload);

      // Dismiss loading toast after response
      toast.dismiss(loadingToastId);

      // Check the response and handle accordingly
      if (response?.success && Array.isArray(response.details)) {
        setLoginName(response.details || []);
      } else {
        toast.error("No users found or invalid response structure.", {
          autoClose: 2000,
          containerId: "orgContainer",
        });
      }
    } catch (err) {
      // Handle errors gracefully
      console.error("Error fetching users:", err);
      toast.dismiss(loadingToastId);
      toast.error("Error fetching users.", {
        autoClose: 2000,
        containerId: "orgContainer",
      });
    }
  };


  const handleSubmit = async (e) => {
    if (!selectedClient || !selectedParentVal || !selectedOrgRollParentVal || !loginName) {
      toast.error("Please select all required fields.");
      return;
    }

    const refUserId = loginName[0]?.id; 

    if (!refUserId) {
      toast.error("Please select a valid login name.");
      return;
    }
  
    const payload = {
      clientid: parseInt(selectedClient, 10),
      organizationid: parseInt(selectedParentVal, 10),
      roleid: parseInt(selectedOrgRollParentVal, 10), 
      refuserid: refUserId,
    };
  
    const loadingToastId = toast.loading("Submitting user role mapping...", {
      toastId: "submitLoading",
      containerId: "submitContainer",
    });
  
    try {
      const response = await insertmapuserrole(payload);
  
      toast.dismiss(loadingToastId);  
  
      if (response?.success) {
        toast.success("User role mapping successful!");
      } else {
        toast.error("Error mapping user role.");
      }
    } catch (err) {
      console.error("Error inserting user role:", err);
      toast.dismiss(loadingToastId); 
      toast.error("Error submitting the form.");
    }
  };
  

  return (
    <div>
      {/* // add client modal pop up  */}
      <div
        className={`fixed inset-0 bg-gray-500 bg-opacity-50 z-50 transition-opacity ${
          isModalOpen ? "block" : "hidden"
        }`}
      >
        <div className="flex justify-center items-center min-h-screen">
          <div className="bg-white p-6 rounded-lg shadow-lg w-6/12">
            <h2 className="text-2xl text-center font-semibold mb-4">
              Map User with Role
            </h2>

            <form onSubmit={handleSubmit}>
              {/* Client Name */}

              <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6 mb-3">
                <div className="mb-3">
                  <label
                    htmlFor="clientName"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Select Client
                  </label>
                  <div className="w-full max-w-sm min-w-[200px]">
                    <div className="relative">
                      <select
                        className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer"
                        value={selectedClient}
                        onChange={(e) => setSelectedClient(e.target.value)}
                      >
                        <option value="">Select Client</option>
                        {clients.map((client, index) => (
                          <option key={index} value={client.id}>
                            {client.name}
                          </option>
                        ))}
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.2"
                        stroke="currentColor"
                        className="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Client Code */}
                <div className="mb-3">
                  <label
                    htmlFor="clientCode"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Select Organization
                  </label>
                  <div className="w-full max-w-sm min-w-[200px]">
                    <div className="relative">
                      <select
                        value={selectedParentVal}
                        className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer"
                        onChange={(e) => setSelectedParentVal(e.target.value)}
                      >
                        <option value="">Select Parent Organization</option>
                        {organizationData.map((org, index) => (
                          <option key={index} value={org.id}>
                            {org.organizationname}
                          </option>
                        ))}
                      </select>

                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.2"
                        stroke="currentColor"
                        className="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="clientCode"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Select Role
                  </label>
                  <div className="w-full max-w-sm min-w-[200px]">
                    <div className="relative">
                      <select
                        value={selectedOrgRollParentVal}
                        className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer"
                        onChange={(e) =>
                          setSelectedOrgRollParentVal(e.target.value)
                        }
                      >
                        <option value="">Select Parent Organization</option>
                        {rollbasedData.map((rollbaseorg, index) => (
                          <option key={index} value={rollbaseorg.id}>
                            {rollbaseorg.rolename}
                          </option>
                        ))}
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.2"
                        stroke="currentColor"
                        className="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label
                    htmlFor="keyPersonEmail"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Login Name
                  </label>
                  <Autocomplete
                    disablePortal
                    options={loginName}
                    sx={{ width: 300 }}
                    getOptionLabel={(option) => option.loginname || ""}
                    onInputChange={(event, value) => handleSearchUser(value)}
                    renderInput={(params) => (
                      <TextField {...params} label="Search By Login Name" />
                    )}
                  />
                </div>
              </div>

              <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
                {/* Submit and Close Buttons */}
                <div className="col-span-2 flex justify-between space-x-4">
                  <button
                    type="submit"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Submit
                  </button>
                  <button
                    onClick={closeModal}
                    className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-400 focus:outline-none"
                  >
                    Close Modal
                  </button>
                </div>
              </div>
            </form>

            {/* Close button */}
          </div>
        </div>
      </div>
      <ToastContainer containerId="clientContainer" />
      <ToastContainer containerId="orgContainer" />
      <ToastContainer containerId="roleContainer" />
    </div>
  );
}

export default AddGyanniUserRoleBase;
